import { useEffect, useState } from "react";

import openSocket from "../../services/socket-io";

// "digitando…" / "gravando áudio…" por ticket.
//
// O estado expira sozinho: o WhatsApp manda o aviso enquanto a pessoa
// escreve, mas não manda nada quando ela para. Sem o tempo limite o rótulo
// ficaria preso na tela para sempre.
const DURACAO_MS = 4000;

const usePresence = () => {
	const [presencas, setPresencas] = useState({});

	useEffect(() => {
		const socket = openSocket();
		const timers = new Map();

		const aoReceber = ({ ticketId, estado }) => {
			if (!ticketId) return;

			setPresencas((atual) => ({ ...atual, [ticketId]: estado }));

			clearTimeout(timers.get(ticketId));
			timers.set(
				ticketId,
				setTimeout(() => {
					setPresencas((atual) => {
						const proximo = { ...atual };
						delete proximo[ticketId];
						return proximo;
					});
					timers.delete(ticketId);
				}, DURACAO_MS)
			);
		};

		socket.on("presence", aoReceber);

		return () => {
			timers.forEach((t) => clearTimeout(t));
			// Só remove o próprio ouvinte: o socket.io-client reaproveita a
			// mesma conexão, e desconectar aqui derrubaria a lista de tickets
			// e as notificações junto.
			socket.off("presence", aoReceber);
		};
	}, []);

	return presencas;
};

export const rotuloPresenca = (estado) => {
	if (estado === "composing") return "digitando…";
	if (estado === "recording") return "gravando áudio…";

	return null;
};

export default usePresence;
